export default __webpack_public_path__ + "static/media/coin_2gm.487b0fee.jpg";